import ComposeInternalLayout from '../components/HOC/ComposeInternalLayout';
import { adminUrl } from '../url/urls';
import Subscriptions from '../pages/admin/Subscriptions/Subscriptions';
import AccountSettings from '../pages/experts/Settings/AccountSettings';
import Dashboard from '../pages/admin/Dashboard/Dashboard';
import AllUsers from '../pages/founder/Allusers/AllUsers';
import UserExperts from '../pages/founder/Allusers/Experts';
import UserInvestors from '../pages/founder/Allusers/Investors';
import UserAddexpert from '../pages/founder/Allusers/Addexpert';
import ViewUser from '../pages/founder/Allusers/ViewUser';
import StartupOffers from '../pages/admin/startup-offers/StartupOffers';
import Adverts from '../pages/admin/adverts/Adverts';
import Brands from '../pages/admin/brands/Brands';
import DeletedUsers from '../pages/admin/deleted-users/DeletedUsers';
import PostReports from '../pages/admin/post-reports/post-reports';
import ProfileReports from '../pages/admin/profile-reports/profile-reports';
import ProfileReportsDetailPage from '../pages/admin/profile-reports/profile-reports-details';
import SubAdmins from '../pages/admin/sub-admins/SubAdmins';
import EventAdminPage from '../pages/admin/events';
import Deals from '../pages/admin/deals/Deals';
import News from '../pages/admin/news/News';
import PitchRequests from '../pages/admin/pitch-requests/PitchRequests';
import ManageSubscriptionPlans from '../pages/admin/Subscriptions/ManageSubscriptionPlans';

export const adminRoutes = [
  {
    title: 'Subscriptions',
    path: adminUrl.subscriptions(),
    element: ComposeInternalLayout(Subscriptions),
  },
  {
    title: 'Pitch Requests',
    path: adminUrl.pitchRequests(),
    element: ComposeInternalLayout(PitchRequests),
  },
  {
    title: 'Dashboard',
    path: adminUrl.dashboard(),
    element: ComposeInternalLayout(Dashboard),
  },
  {
    title: 'Account Settings',
    path: adminUrl.accountSettings(),
    element: ComposeInternalLayout(AccountSettings),
  },
  {
    title: 'Users',
    path: adminUrl.allUsers(),
    element: ComposeInternalLayout(AllUsers),
  },
  {
    title: 'Startup Offers',
    path: adminUrl.startupOffers(),
    element: ComposeInternalLayout(StartupOffers),
  },
  {
    title: 'Brands',
    path: adminUrl.brands(),
    element: ComposeInternalLayout(Brands),
  },
  {
    title: 'News',
    path: adminUrl.news(),
    element: ComposeInternalLayout(News),
  },
  {
    title: 'User experts',
    path: adminUrl.userExperts(),
    element: ComposeInternalLayout(UserExperts),
  },
  {
    title: 'User investors',
    path: adminUrl.userInvestors(),
    element: ComposeInternalLayout(UserInvestors),
  },
  {
    title: 'User addexpert',
    path: adminUrl.userAddExpert(),
    element: ComposeInternalLayout(UserAddexpert),
  },
  {
    title: 'View User',
    path: adminUrl.viewUser(),
    element: ComposeInternalLayout(ViewUser),
  },
  {
    title: 'Adverts',
    path: adminUrl.adverts(),
    element: ComposeInternalLayout(Adverts),
  },
  {
    title: 'Deleted Users',
    path: adminUrl.deletedUsers(),
    element: ComposeInternalLayout(DeletedUsers),
  },
  {
    title: 'Sub Admins',
    path: adminUrl.subadmins(),
    element: ComposeInternalLayout(SubAdmins),
  },
  {
    title: 'Post Reports',
    path: adminUrl.postReports(),
    element: ComposeInternalLayout(PostReports),
  },
  {
    title: 'Profile Reports',
    path: adminUrl.profileReports(),
    element: ComposeInternalLayout(ProfileReports),
  },
  {
    title: 'Deals',
    path: adminUrl.deals(),
    element: ComposeInternalLayout(Deals),
  },
  {
    title: 'Profile Reports Details',
    path: adminUrl.profileReportsDetails(),
    element: ComposeInternalLayout(ProfileReportsDetailPage),
  },

  {
    title: 'Events',
    path: adminUrl.events(),
    element: ComposeInternalLayout(EventAdminPage),
  },
  {
    title: "Manage Subscription Plans",
    path: adminUrl.manageSubscriptionPlans(),
    element: ComposeInternalLayout(ManageSubscriptionPlans),
  }
];
